import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-screen bg-primary-light flex flex-col items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl text-primary-dark mb-8" }, "Rezepte", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.query.loading.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Laden..."))
      : (_ctx.query.error.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Fehler!"))
        : (_openBlock(), _createElementBlock("a", {
            key: 2,
            href: _ctx.loginUrl,
            class: "bg-white border-primary-dark border-2 rounded-lg px-4 py-2 text-xl font-semibold"
          }, "Anmelden", 8, _hoisted_5))
  ]))
}